export const devLog = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console -- devLog sink
    console.log(...args);
  }
};
